import { cn } from "@/lib/utils";

const styles = {
  shadowed: "text-red-400 bg-red-500/10 border-red-500/30",
  redundant: "text-amber-400 bg-amber-500/10 border-amber-500/30",
  overlap: "text-blue-400 bg-blue-500/10 border-blue-500/30",
  clean: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
};

const dots = {
  shadowed: "bg-red-500",
  redundant: "bg-amber-500",
  overlap: "bg-blue-500",
  clean: "bg-emerald-500",
};

export const StatusBadge = ({ status }) => {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm border text-[10px] font-mono tracking-[0.15em]",
        styles[status] || styles.clean
      )}
    >
      <span className={cn("h-1 w-1 rounded-full", dots[status] || dots.clean)} />
      {(status || "clean").toUpperCase()}
    </span>
  );
};
